import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomerService from '../../service/CustomerService';
import AuthContext from '../../context/AuthContext';
import { Card, Col, Row } from 'react-bootstrap';

const ProfileInfoCard = ({ data }) => {
    const {
        companyName,
        address,
        primaryPhone,
        secondaryPhone,
        city,
        state,
        country,
        email,
        website
    } = data;

    return (
        <Card className="customer-profile col-md-6">
            <Card.Body className='p-0'>
                <h4 className="com_name">{companyName}</h4>
                <Row>
                    <Col md={6} className="profile_info">
                        <p><strong>Address</strong> {address ? address : "NA"}</p>
                    </Col>
                    <Col md={6} className="profile_info">
                        <p><strong>City</strong> {city ? city : "NA"}</p>
                    </Col>
                    <Col md={6} className="profile_info">
                        <p><strong>State</strong> {state ? state : "NA"}</p>
                    </Col>
                    <Col md={6} className="profile_info">
                        <p><strong>Country</strong> {country ? country : "NA"}</p>
                    </Col>
                    <Col md={6} className="profile_info">
                        <p><strong>Primary Phone</strong> {primaryPhone ? primaryPhone : "NA"}</p>
                    </Col>
                    <Col md={6} className="profile_info">
                        <p><strong>Secondary Phone</strong> {secondaryPhone ? secondaryPhone : "NA"}</p>
                    </Col>
                    <Col md={6} className="profile_info">
                        <p><strong>Email</strong> {email ? email : "NA"}</p>
                    </Col>
                    <Col md={6} className="profile_info">
                        <p><strong>Website</strong>{website ? website : "NA"}</p>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

function ProfilePage() {
    const { user, isLoggedIn, logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const [me, setMe] = useState(null);

    useEffect(() => {
        if (!isLoggedIn()) {
            navigate('/login');
            return;
        }

        // Fetch profile details
        const fetchProfile = async () => {
            try {
                if (user?.token) {
                const response = await CustomerService.getMe(user.token);
                setMe(response);
                }
            } catch (error) {
                console.error('Failed to fetch profile:', error);
                logout();
                navigate('/login');
            }
        };

        fetchProfile();
    }, [isLoggedIn, logout, user, navigate]);

    return (
        <section className='global-padding profile_page min-h-400'>
        <div className="container">
            <div className='row justify-content-center m-0'>
            {!me ? (
                <div className="d-flex justify-content-center align-items-center">
                    <div className="text-center">
                        <div className="spinner-border text-primary mb-3" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="text-muted">Loading profile...</p>
                    </div>
                </div>
            ) : (
                <>
                    <ProfileInfoCard data={me} />

                    <div className="row mt-4 justify-content-center">
                        <div className="col-md-3 mb-3">
                            <button
                                className="btn_profile"
                                style={{ backgroundColor: '#c70000' }}
                                onClick={() => navigate('/listings')}
                            >
                                My Advertisements
                            </button>
                        </div>
                        <div className="col-md-3 mb-3">
                            <button
                                className="btn_profile"
                                style={{ backgroundColor: '#003e87' }}
                                onClick={() => navigate('/leads')}
                            >
                                Leads
                            </button>
                        </div>
                    </div>
                </>
            )}
        </div>
        </div>
        </section>
    );
}

export default ProfilePage;
